//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import elementLine from './element-line.vue';
import tasksList from './tasks-list.vue';
import {calcVisibility} from '../utils.js'
import {elementsPreviewsSet} from '../component-registers.js'
import {
  foldTask,
  unfoldTask,
} from '../db-utils.js';

export default {
  props: ['task'],
  components: {
    elementLine,
    tasksList,
  },
  data() {
    return {
      hoverActive: false,
      isMobile: (('ontouchstart' in window) ||
                 (window.navigator.msMaxTouchPoints > 0)),
    };
  },
  computed: {
    // should this be a prop?
    elements() {
      return this.task.getChildren();
    },
    elementCount() {
      return this.elements.length;
    },
    foldedElements() {
      if (this.elements.length <= 2) {
        return this.elements;
      }
      if (this.task.showNotesInPreview) {
        // Hidden feature for better narration flow in tutorial.
        return [this.elements[0]]
      }
      const taskAndPending =
          (t) => t.type === 'task' && !t.doneAtTimestampMs;
      return [this.elements.find(taskAndPending) || this.elements[0]];
    },
    visibleElements() {
      if (this.task.localFolded) {
        return this.foldedElements;
      }
      return this.elements;
    },
    foldButtonHint() {
      return this.task.localFolded
        ? this.$gettext('Unfold elements')
        : this.$gettext('Fold elements')
    },
  },
  methods: {
    visible(task) {
      return calcVisibility(task, this);
    },
    toggleFoldElements() {
      if (this.task.localFolded) {
        unfoldTask(this.task);
      } else {
        foldTask(this.task);
      }
    },
    onDragIn() {
      this.$refs.dropZoneFrame.classList.add('active');
      this.$emit('dragEntered');
    },
    onDragOut() {
      this.$refs.dropZoneFrame.classList.remove('active');
      this.$emit('dragLeft');
    },
    onDragStarted() {
      if (this.$taskCardsController.selectedTasksIds &&
          this.$taskCardsController.selectedTasksIds[this.task._id]) {
        // This task is selected, and its elements preview should stay
        // inactive.
        return;
      }
      this.$refs.topFiller.style.display = 'block';
      this.$refs.dropZoneFrame.style.display = 'flex';
    },
    onDragFinished() {
      this.$refs.topFiller.style.display = 'none';
      this.$refs.dropZoneFrame.style.display = 'none';
    },
    setDropZoneHighlight(hovering) {
      if (hovering) {
        this.$refs.dropZoneFrame.classList.add('ready');
      } else {
        this.$refs.dropZoneFrame.classList.remove('ready');
      }
    },
  },
  mounted() {
    elementsPreviewsSet.add(this);
  },
  beforeDestroy() {
    elementsPreviewsSet.delete(this);
  },
};
